import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class SlideshowButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SlideshowButtonStyle>): SlideshowButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new SlideshowButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
